<template>
  <div>
    <Navbar />
    <div class="container">
      <div class="row header mt-5 mb-5">
        <div class="offset-md-2 col-md-8">
          <h1>{{ name }}</h1>
        </div>
      </div>
      <LoadingWrapper :loading-bool="loading">
        <div class="row mb-5">
          <div class="offset-md-2 col-md-8">
            <b-card :title="title" class="shadow">
              <b-alert v-for="(error, index) in errors" :key="index"
                       show
                       variant="danger">
                {{ error }}
              </b-alert>
              <b-form v-if="name" class="mt-4" @submit="onSubmit">
                <b-form-group label="Project Name:" label-for="input-1">
                  <b-form-input
                    id="input-1"
                    v-model="name"
                    placeholder="Give your project a name"
                    required
                  />
                </b-form-group>

                <b-form-group label="URL (Optional):" label-for="input-2">
                  <b-form-input
                    id="input-2"
                    v-model="url"
                    placeholder="e.g. www.heurix.io"
                  />
                </b-form-group>

                <b-form-group v-if="redirectToEvaluation"
                              label="Which sections would you like to include in your evaluation?">
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-checkbox-group
                        id="sections-checkbox-group-1"
                        v-model="sections"
                        :options="sectionOptionsBoxes.slice(0, 4)"
                        name="flavour-1"
                        switches
                        stacked
                        @change="maybeSetSelectAllToggle"
                      />
                    </div>
                    <div class="col-md-6">
                      <b-form-checkbox-group
                        id="sections-checkbox-group-2"
                        v-model="sections"
                        :options="sectionOptionsBoxes.slice(4)"
                        name="flavour-1"
                        switches
                        stacked
                        @change="maybeSetSelectAllToggle"
                      />
                    </div>
                    <div class="col">
                      <b-form-invalid-feedback :state="sectionsValid">
                        You must select at least one section to evaluate.
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <hr>
                  <b-form-checkbox-group
                    id="sections-checkbox-select-all"
                    v-model="selectAll"
                    :options="[{text: 'Select All', value: true}]"
                    switches
                    stacked
                    @change="toggleSelectAll"
                  />
                </b-form-group>

                <b-button type="submit" variant="primary"
                          :pressed="submitting"
                          :disabled="!canSubmit">
                  Get Started
                </b-button>
              </b-form>
            </b-card>
          </div>
        </div>
      </LoadingWrapper>
    </div>
    <Footer />
  </div>
</template>

<script>
  import apiMixin from "../../utils/api"
  import LoadingWrapper from "../navigation/LoadingWrapper"
  import Footer from "../navigation/Footer"
  import Navbar from "../navigation/Navbar"

  const sectionOptions = {
    'First Impressions': 0,
    'Site Navigation': 1,
    'Information': 2,
    'Trust and Persuasion': 3,
    'Interaction': 4,
    'Forms': 5,
    'Search': 6
  }
  export default {
    name: 'SiteEdit',
    components: {Footer, LoadingWrapper, Navbar},
    mixins: [apiMixin],
    props: {
      siteId: {type: Number, required: true},
      redirectToEvaluation: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        name: null,
        url: null,
        sections: [],
        errors: [],
        submitting: false,
        sectionOptionsBoxes: Object.keys(sectionOptions).map(key => ({text: key, value: sectionOptions[key]})),
        selectAll: []
      }
    },
    computed: {
      sectionsValid() {
        return Boolean(this.sections && this.sections.length)
      },
      canSubmit() {
        const {submitting, sectionsValid, name} = this
        return !submitting && sectionsValid && name
      },
      title() {
        return this.redirectToEvaluation ? 'Re-evaluate Site' : 'Edit site information'
      }
    },
    methods: {
      toggleSelectAll() {
        this.sections = this.selectAll[0] ? [] : [0, 1, 2, 3, 4, 5, 6]
      },
      maybeSetSelectAllToggle() {
        setTimeout(() => {
          if (this.sections.length === 7) {
            this.selectAll = [true]
          } else {
            this.selectAll = []
          }
        }, 50)
      },
      load() {
        this.withLoading(async () => {
          try {
            const {name, url, pending_evaluation_id, response_format} = (await this.get(
              `/api/sites/${this.siteId}/`,
            ))
            this.name = name
            this.url = url
            this.sections = response_format.map(section => sectionOptions[section.name])
            this.maybeSetSelectAllToggle()
            if (this.redirectToEvaluation && pending_evaluation_id) {
              return this.$router.push({name: 'site.list'})
            }
          } catch (e) {
            return this.error = e.error
          }
        })
      },
      async onSubmit(e) {
        e.preventDefault()
        this.errors = []
        this.submitting = true

        try {
          const {name, url, sections} = this
          await this.put(
            `/api/sites/${this.siteId}/`,
            {name, url, sections}
          )
          if (this.redirectToEvaluation) {
            await this.$router.push({name: 'evaluation.create', params: {siteId: this.siteId}})
          } else {
            await this.$router.push({name: 'site.list'})
          }
        } catch (e) {
          this.submitting = false
          this.catchApiError(e)
        }
      },
    }
  }
</script>
